import React from 'react';
import CustomButton from 'components/CustomButtons/Button';
import Close from '@material-ui/icons/Close';
import style from 'assets/jss/material-dashboard-pro-react/views/contactUs/registeringComplaintStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import { HeadingMBold, BodyS } from 'components/Typography/Typography';
import ArrowRight from '@material-ui/icons/KeyboardArrowRight';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(style);

interface FailureProps {
	onClose: () => void;
}

const Failure = ({ onClose }: FailureProps) => {
	const classes = useStyles();
	return (
		<div className={classes.responseWrapper}>
			<div className={classNames(classes.oval, classes.ovalError)}>
				<Close />
			</div>
			<HeadingMBold disableMargin>{translate('something.went.wrong')}</HeadingMBold>
			<div className={classes.registerTicketFailureMessageWrapper}>
				<BodyS disableMargin color="primary-light">
					{translate('contact.us.register.ticket.failure.message')}
				</BodyS>
			</div>
			<CustomButton color="tertiary-light" onClick={onClose} withIcon className={classes.newMessageButton}>
				<>
					{translate('try.again.button')}
					<ArrowRight />
				</>
			</CustomButton>
		</div>
	);
};

export default Failure;
